import React, { useRef, useState } from 'react';
import { IconMinus, IconPlus } from '@noths/polaris-client-ribbons-design-system';

import { useExpandableText } from './useExpandableText';
import * as styles from './PressComment.styles';

const LINES_OF_TEXT_WHEN_COLLAPSED = 3;

export interface PressCommentProps {
  comment: string;
  date: string;
  href: string;
  source: string;
}

export const PressComment = ({ comment, date, href, source }: PressCommentProps) => {
  const commentRef = useRef<HTMLParagraphElement>(null);
  const [expanded, setExpanded] = useState(false);
  const { expandedHeight, height, lineCount } = useExpandableText({
    ref: commentRef,
    maxLines: LINES_OF_TEXT_WHEN_COLLAPSED,
  });
  const dateObj = new Date(date);

  const toggleExpanded = () => setExpanded((prev) => !prev);

  return (
    <article css={styles.root}>
      <div css={styles.header}>
        <a href={href} rel="noreferrer" target="_blank">
          {source}
        </a>
        <time dateTime={dateObj.toISOString()}>{dateObj.toLocaleDateString()}</time>
      </div>
      <div
        css={[
          styles.commentText,
          !expanded && lineCount > LINES_OF_TEXT_WHEN_COLLAPSED && styles.commentTextCollapsed,
        ]}
        style={{
          height: expanded ? expandedHeight : height,
        }}
      >
        <p ref={commentRef}>{comment}</p>
      </div>
      {lineCount > LINES_OF_TEXT_WHEN_COLLAPSED && (
        <button css={styles.expandingButton} onClick={toggleExpanded}>
          <span css={styles.readMoreButtonText}>Read {expanded ? 'less' : 'more'}</span>
          {expanded ? (
            <IconMinus color={'var(--brand-purple-base)'} height={16} width={16} />
          ) : (
            <IconPlus color={'var(--brand-purple-base)'} height={16} width={16} />
          )}
        </button>
      )}
    </article>
  );
};
